import * as React from "react"

import Home from "../components/update"
import Seo from "../components/seo"

const PwaPage = () => (
<Home>
<Seo title="Progresive Web App pembuatan website aplikasi all in one" />
<div className="container">
<div className="row mt-5">
<div className="col-md-6 p-3 p-md-5 mt-5 mb-5">
<h1><strong><a href="/pwa/">Progresive Web App</a></strong></h1>
<h2>Progresive Web App pembuatan website aplikasi all in one</h2>
<p>Ingin membangun dan membuat website yang memungkinkan pengunjung situs untuk melakukan installasi pada perangkat mereka baik desktop maupun mobile smartphone android ios maka penggunaan progresive web app adalah solusi yang paling tepat untuk digunakan, dalam penerapan nya , kita tidak saja membuat website tetapi juga include dengan aplikasi yang dapat di install pada perangkat visitor.</p>
<ul className="nav nav-pills mb-3" id="pills-tab">
  <li className="nav-item p-1" role="presentation">
    <button className="btn btn-dark btn-sm active" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true">Demo 1</button>
  </li>
  <li className="nav-item p-1" role="presentation">
    <button className="btn btn-dark btn-sm" id="pills-demokasir-tab" data-bs-toggle="pill" data-bs-target="#pills-demokasir" type="button" role="tab" aria-controls="pills-demokasir" aria-selected="false">Demo 2</button>
  </li>
  <li className="nav-item p-1" role="presentation">
    <button className="btn btn-dark btn-sm" id="pills-hotel-tab" data-bs-toggle="pill" data-bs-target="#pills-hotel" type="button" role="tab" aria-controls="pills-hotel" aria-selected="false">Demo 3</button>
  </li>
 
</ul>
</div>
<div className="col-md-6 p-3 p-md-5 mt-5 mb-5">

<div className="tab-content" id="pills-tabContent">
  <div className="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
<div className="ratio ratio-16x9">
  <iframe width="560" height="315" className="rounded" src="https://www.youtube.com/embed/XothlXz_bok" title="Pembuatan website progresive web app"></iframe>
</div>
  </div>
  <div className="tab-pane fade" id="pills-demokasir" role="tabpanel" aria-labelledby="pills-demokasir-tab">
  <div className="ratio ratio-16x9">
  <iframe width="560" height="315" className="rounded" src="https://www.youtube.com/embed/_FuyyboECHA" title="Pembuatan website mobile app"></iframe>
</div>
  </div>
  <div className="tab-pane fade" id="pills-hotel" role="tabpanel" aria-labelledby="pills-hotel-tab">
  <div className="ratio ratio-16x9">
  <iframe width="560" height="315" className="rounded" src="https://www.youtube.com/embed/1NEr74eUvCI" title="Pembuatan website terbaru modern technology"></iframe>
</div>
  </div>

  </div>
  

</div>

</div>
</div>
</Home>
)

export default PwaPage